import React, { useEffect, useState } from 'react'
import styles from "./product.module.css";
import { LuImage } from "react-icons/lu";

const DEFAULT_CLASSES = {
  container: styles.productContainer,
  imageContainer: styles.productImageContainer,
  image: styles.productImage,
  imagePlaceholder: styles.productImagePlaceholder,
  priceContainer: styles.productPriceContainer,
  content: styles.productContent,
  name: styles.productName,
  description: styles.productDescription
};

const DEFAULT_IMAGE = {
  src: "",
  alt: ""
};

export default function Product({
    product={},
    image={},
    onClick=()=>{},
    priceDisplay="Price unavailable",
    productClassesOverride={},
    productStyles={}
}) {
  const classes = { ...DEFAULT_CLASSES, ...productClassesOverride };
  const productImage = { ...DEFAULT_IMAGE, ...image };

  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [productImage.src]);

  return (
    <div className={classes.container} style={productStyles.container} onClick={onClick}>
      <div className={classes.imageContainer} style={productStyles.imageContainer}>
        {productImage.src && !imageFailed ? (
          <img
            src={productImage.src}
            alt={productImage.alt}
            className={classes.image}
            style={productStyles.image}
            onError={() => setImageFailed(true)}
          />
        ) : (
            <LuImage
              size={48}
              className={classes.imagePlaceholder}
              style={productStyles.imagePlaceholder}
            />
        )}
        <div className={classes.priceContainer} style={productStyles.priceContainer}>
          {priceDisplay}
        </div>
      </div>
      <div className={classes.content} style={productStyles.content}>
        <h1 className={classes.name} style={productStyles.name}>{product.name}</h1>
        <p className={classes.description} style={productStyles.description}>{product.description}</p>
      </div>
    </div>
  )
}
